export default __webpack_public_path__ + "static/media/HDTX_Pemanggilan RUPS 2021.c3d67f7c.pdf";